import React from 'react';

// Types
interface QNavFooterProps {
  signOut: () => void;
}

const QNavFooter: React.FC<QNavFooterProps> = ({ signOut }) => {
  return (
    <footer className="bg-background-menu text-white py-3 px-6 border-t border-secondary-700">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="flex items-center mb-3 md:mb-0">
          <div className="h-6 w-6 rounded bg-brand-orange flex items-center justify-center mr-2">
            <span className="text-brand-blue font-bold text-xs">Q</span>
          </div>
          <span className="text-sm">Q-Navigator © {new Date().getFullYear()}</span>
        </div>

        <div className="flex items-center space-x-6">
          <button onClick={signOut} className="text-xs text-secondary-400 hover:text-white">
            Sign Out
          </button>
          <button className="text-xs text-secondary-400 hover:text-white">Terms</button>
          <button className="text-xs text-secondary-400 hover:text-white">Privacy</button>
        </div>
      </div>
    </footer>
  );
};

export { QNavFooter };
